import Header from "../components/Header";
import Footer from "../components/Footer";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      <main className="max-w-2xl mx-auto px-4 py-12">
        <h1 className="text-2xl font-bold text-gray-900 mb-2 text-center">
          Privacy Policy
        </h1>
        <p className="text-sm text-gray-600 mb-12 text-center leading-relaxed">
          Society of Aquaculture Professionals (“we”, “our”, “us”) operates the
          event registration and conference services for Aqua India 2026, hosted
          via the website societyofaquacultureprofessionals.org.
        </p>

        <div className="space-y-8">
          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-4 border-b border-gray-300 pb-1">
              Information We Collect
            </h2>
            <div className="space-y-2 text-sm text-gray-700 leading-relaxed">
              <div>
                • Name, email address, phone number, organization details
              </div>
              <div>• Billing and payment information</div>
              <div>
                • IP address, browser/device details, and usage analytics
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-4 border-b border-gray-300 pb-1">
              How We Use Your Information
            </h2>
            <div className="space-y-2 text-sm text-gray-700 leading-relaxed">
              <div>• Processing event registration and payments</div>
              <div>• Providing event participation updates and services</div>
              <div>• Improving website performance and security</div>
            </div>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-4 border-b border-gray-300 pb-1">
              Data Sharing
            </h2>
            <div className="space-y-2 text-sm text-gray-700 leading-relaxed">
              <div>We do not sell or rent your personal data.</div>
              <div>Data may be shared only with:</div>
              <div>• Payment service providers for processing transactions</div>
              <div>• Government or legal authorities when required</div>
            </div>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-4 border-b border-gray-300 pb-1">
              Data Protection
            </h2>
            <div className="text-sm text-gray-700 leading-relaxed">
              We use appropriate technical measures to safeguard information.
              However, absolute security cannot be guaranteed due to the nature
              of the internet.
            </div>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-4 border-b border-gray-300 pb-1">
              Retention
            </h2>
            <div className="text-sm text-gray-700 leading-relaxed">
              Your data will be retained only as long as necessary for event
              administration and compliance with legal obligations.
            </div>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-4 border-b border-gray-300 pb-1">
              Your Rights
            </h2>
            <div className="text-sm text-gray-700 leading-relaxed">
              You may request access, correction, or deletion of your personal
              data by contacting us through our official website communication
              channels.
            </div>
          </section>
        </div>

        <div className="mt-16 pt-8 border-t border-gray-200 text-center">
          <p className="text-sm font-medium text-gray-900 leading-relaxed">
            By registering for Aqua India 2026, you consent to this Privacy
            Policy.
          </p>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
